class Blobber {
  static createDataURI(blob: Blob): Promise<string> {
    return new Promise((res, rej) => {
      const reader = new FileReader()
      reader.onload = () => {
        if (!reader.result)
          return rej({
            reason: "unable to convert blob to dataURI",
            type: "createDataURI Error",
          })

        res(reader.result.toString())
      }
      reader.onerror = err => rej(err)
      reader.readAsDataURL(blob)
    })
  }
  static fromDataURI(dataURI: string) {
    try {
      if (!dataURI || !dataURI.includes(",")) {
        throw new Error("Invalid dataURI format")
      }

      const parts = dataURI.split(",")
      // convert base64 to raw binary data held in a string
      var byteString = atob(parts[1])

      // separate out the mime component
      var header = parts[0]
      var mime = header.split(":")[1]?.split(";")[0] || "image/jpeg"

      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length)

      // create a view into the buffer
      var ia = new Uint8Array(ab)

      // set the bytes of the buffer to the correct values
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      // write the ArrayBuffer to a blob, and you're done
      return new Blob([ab], { type: mime })
    } catch (e: any) {
      console.error("Blobber.fromDataURI failed:", e.message)
      throw e
    }
  }
}
export default Blobber
